import { AccountCircle } from "@mui/icons-material";
import { AppBar, Avatar, IconButton, Menu, MenuItem, Snackbar, Toolbar, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { auth } from "./firebase";

export default function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { currentUser, isContractor } = useAuth();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    console.log("プロフィール画面に遷移");
    // プロフィール画面（Profile/index.jsx)に遷移する処理
    navigate("/profile");
    handleClose();
  };

  const handleCreate = () => {
    console.log("勤怠登録画面に遷移");
    navigate("/");
    handleClose();
  };

  const handleLogout = () => {
    console.log("ログアウト処理");
    auth.signOut().then(() => {
      setSnackbarOpen(true);
      handleClose();
    }).catch((error) => {
      console.error("Log out error", error);
    });
    handleClose();
  };

  const handleClickTypo = () => {
    navigate("/");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: isContractor ? "#4caf50" : "#1976d2",
      }}
    >
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: "bold" }} onClick={handleClickTypo}>
          {process.env.REACT_APP_DEV_MODE
            ? `[開発環境] ${isContractor ? "稼働管理" : "勤怠管理"}`
            : isContractor
            ? "稼働管理"
            : "勤怠管理"}
        </Typography>
        {currentUser && (
          <Typography variant="h6" sx={{ marginRight: 2 }}>
            {currentUser.displayName || currentUser.email}
          </Typography>
        )}
        <IconButton onClick={handleClick} size="large" edge="end" color="inherit">
          <Avatar>
            <AccountCircle />
          </Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleCreate}>稼働管理</MenuItem>
          <MenuItem onClick={handleProfile}>プロフィール</MenuItem>
          <MenuItem onClick={handleLogout}>ログアウト</MenuItem>
        </Menu>
      </Toolbar>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message="ログアウトしました"
      />
    </AppBar>
  );
}
